module.exports = __webpack_public_path__ + "img/kangwonland-login.42ae4319.svg";